"use client";

import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ProminentGetQuoteCTA() {
  const reduceMotion = useReducedMotion();
  return <section data-section-id="24648" id="prominentgetquotecta" data-nav="dark" className="relative overflow-hidden bg-[hsl(220,40%,15%)] text-white py-16 md:py-24 px-5 md:px-10">
      {}
      <div aria-hidden="true" className="absolute inset-x-0 bottom-0 pointer-events-none opacity-[0.06] flex justify-center overflow-hidden">
        <svg viewBox="0 0 1440 200" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto min-w-[1000px]">
          <path d="M0 200L160 140L320 170L480 80L640 120L800 40L960 100L1120 60L1280 150L1440 90V200H0Z" fill="currentColor" />
        </svg>
      </div>

      <motion.div initial={reduceMotion ? {
      opacity: 1
    } : {
      opacity: 0,
      y: 20
    }} whileInView={reduceMotion ? {
      opacity: 1
    } : {
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.52,
      ease: [0.2, 0.6, 0.2, 1]
    }} className="relative z-10 mx-auto max-w-[1360px]">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 items-center">
          {}
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <span aria-hidden="true" className="inline-block h-3 w-[1.5px] bg-[hsl(150,60%,35%)]" />
              <span className="font-sans font-semibold uppercase text-[hsl(150,60%,35%)]" style={{
              fontSize: "clamp(0.75rem, 0.85vw, 0.8125rem)",
              letterSpacing: "0.22em",
              lineHeight: 1
            }}>
                Get Started
              </span>
              <span aria-hidden="true" className="inline-block h-3 w-[1.5px] bg-[hsl(150,60%,35%)]" />
            </div>

            <h2 className="font-mono font-bold uppercase text-white" style={{
            fontSize: "clamp(2rem, 4.4vw, 3.5rem)",
            lineHeight: 1.1,
            letterSpacing: "-0.005em"
          }}>
              READY FOR YOUR ASCENT?
            </h2>
          </div>

          {}
          <div className="md:col-span-5 flex flex-col items-start md:items-end justify-center w-full">
            <motion.div whileHover={reduceMotion ? undefined : {
            scale: 1.05
          }} whileTap={reduceMotion ? undefined : {
            scale: 0.97
          }} transition={{
            duration: 0.2,
            ease: "easeOut"
          }} className="w-full md:w-auto">
              <Button asChild className="w-full md:w-auto bg-[hsl(150,60%,35%)] text-[hsl(220,40%,15%)] hover:bg-[hsl(150,60%,30%)] shadow-lg h-16 md:h-20 px-10 gap-3 transition-all duration-200">
                <Link to="/GetAQuotePage" aria-label="Get a personalized quote from Summit Cleaners" className="flex items-center justify-center font-sans font-bold uppercase" style={{
                letterSpacing: "0.04em",
                fontSize: "clamp(1rem, 1.2vw, 1.25rem)"
              }}>
                  GET A QUOTE
                </Link>
              </Button>
            </motion.div>
          </div>
        </div>
      </motion.div>
    </section>;
}